/* @flow */
/**
 * Manufacturer: applications need one.
 * The types contained in this file should not be changed lightly as they are stored on the CMR (kwanza) and user by other software (e.g. Manatee) which expects them to look a certain way.
 * @typedef { Object } Manufacturer
 * @memberof ManufacturerService
 */
import Typenames from './Typenames'
import { ActionTypes, store } from 'store'

export type Manufacturer = {
  id?: string,
  name: string,
  version?: string
}

/**
 * Manufacturer typename
 * @private
 * @memberof ManufacturerService
 */
const TYPENAME = Typenames.MANUFACTURER

/**
 * Creates a new manufacturer.
 * @function
 * @memberof ManufacturerService
 *
 * @return { Promise<string> } The id of the added manufacturer.
 */
const createManufacturer = (manufacturer: Manufacturer): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.CREATE, { typename: TYPENAME, item: manufacturer })
}

/**
 * Reads a manufacturer, flattening 'descriptive'.
 * @function
 * @memberof ManufacturerService
 *
 * @return { Promise<Manufacturer> } The manufacturer.
 */
const readManufacturer = (id: string): Promise<Manufacturer> => {
  return store.dispatch(ActionTypes.GET_BY_ID, { typename: TYPENAME, id: id })
}

/**
 * Updates a manufacturer.
 * @function
 * @memberof ManufacturerService
 *
 * @return { Promise<any> }
 */
const updateManufacturer = (id: string, manufacturer: Manufacturer): Promise<PostResponse> => {
  return store.dispatch(ActionTypes.UPDATE, { typename: TYPENAME, id: id, item: manufacturer })
}

/**
 * Deletes a manufacturer.
 * @function
 * @memberof ManufacturerService
 *
 * @return { Promise<any> }
 */
const deleteManufacturer = (id: string): Promise<any> => {
  return store.dispatch(ActionTypes.DELETE, { typename: TYPENAME, id: id })
}

/**
 * Reads all manufacturers flattening descriptive.
 * @function
 * @memberof ManufacturerService
 *
 * @return { Observable<Array<Manufacturer>> } All the manufacturers.
 */
const readAllManufacturers = (): Promise<Array<Manufacturer>> => {
  return store.dispatch(ActionTypes.GET, TYPENAME)
}

const self = {
  createManufacturer,
  readManufacturer,
  updateManufacturer,
  deleteManufacturer,
  readAllManufacturers
}

/**
 * Manufacturer service: CRUD interface for manufacturers.
 *
 * @module ManufacturerService
 * @namespace ManufacturerService
 * @version 1.0.0
 */
export default self
